import { Event } from './event.interface';
import { ObservableArrayChangedEvent } from './observable-array-changed-event';

export interface IObservableArray<T> extends Array<T> {
  readonly history: Event<ObservableArrayChangedEvent<T>>;
  readonly onChanged: Event<ObservableArrayChangedEvent<T>>;
}
